import { useRef, useEffect } from 'react'

import { pressDelay } from '@/constants/common'

export const useKeyThrottle = () => {
  const lastPress = useRef(0)

  const onKeyPress = (e: KeyboardEvent) => {
    const now = Date.now()
    if (now - lastPress.current < pressDelay) {
      e.stopPropagation()
    } else {
      lastPress.current = now
    }
  }

  const onKeyUp = () => {
    lastPress.current = 0
  }

  useEffect(() => {
    window.addEventListener('keydown', onKeyPress, true)
    window.addEventListener('keyup', onKeyUp)
    return () => {
      window.removeEventListener('keydown', onKeyPress)
      window.removeEventListener('keyup', onKeyUp)
    }
  }, [])
}
